export default {
  projectStatus: {
    // A- / V- flow statuses
    created: 'Created',
    ordered: 'Ordered',
    confirmed: 'Confirmed',
    planned: 'Planned',
    is_being_packed: 'Being Packed',
    packaged: 'Packaged',
    setup: 'Set Up',
    dismantled: 'Dismantled',
    shipped: 'Shipped',
    retourned: 'Returned',
    stored: 'Stored',
    completed: 'Completed',
    // Generic project lifecycle statuses
    inquiry: 'Inquiry',
    quote: 'Quote',
    in_progress: 'In Progress',
    post_calculation: 'Post-Calculation',
    lost: 'Project Lost',
    cancelled: 'Cancelled',
    ongoing: 'Ongoing Service',
    internal: 'Internal Projects',
    // Legacy value kept for older records
    draft: 'Draft',
  },
}
